import {
  Banknote, Coins, Laptop, KeyRound, TrendingUp, TrendingDown, PlusCircle, ShoppingCart,
  Home, Receipt, Car, HeartPulse, GraduationCap, Shirt, Gamepad2, Tv, MoreHorizontal,
  Briefcase, Wallet, Utensils, Gift, PiggyBank, Wrench, Plane, Phone, Dumbbell,
  PawPrint, Bus, Baby, Music, BookOpen, Fuel,
} from "lucide-react";

export const ICON_MAP = {
  banknote: Banknote, coins: Coins, laptop: Laptop, "key-round": KeyRound,
  "trending-up": TrendingUp, "trending-down": TrendingDown, "plus-circle": PlusCircle,
  "shopping-cart": ShoppingCart, home: Home, receipt: Receipt, car: Car,
  "heart-pulse": HeartPulse, "graduation-cap": GraduationCap, shirt: Shirt,
  "gamepad-2": Gamepad2, tv: Tv, "more-horizontal": MoreHorizontal,
  briefcase: Briefcase, wallet: Wallet, utensils: Utensils, gift: Gift,
  "piggy-bank": PiggyBank, wrench: Wrench, plane: Plane, phone: Phone,
  dumbbell: Dumbbell, "paw-print": PawPrint, bus: Bus, baby: Baby,
  music: Music, "book-open": BookOpen, fuel: Fuel,
};

export const ICON_CHOICES = Object.keys(ICON_MAP);

export const COLOR_CHOICES = [
  "#10B981", "#34D399", "#A3E635", "#F59E0B", "#F97316", "#EF4444",
  "#EC4899", "#D946EF", "#8B5CF6", "#6366F1", "#3B82F6", "#06B6D4",
  "#2DD4BF", "#94A3B8",
];

export function getCatMeta(meta, category, type) {
  const m = meta?.[category];
  return {
    Icon: ICON_MAP[m?.icon] || (type === "income" ? TrendingUp : TrendingDown),
    color: m?.color || (type === "income" ? "#10B981" : "#EF4444"),
  };
}
